import React, { useState, useEffect } from "react";
import { ProjectTypeType } from "types/project-type";
import "./project-type-header.scss";

function ProjectTypeHeader({ ProductType, setShowCildren, showCildren }: { ProductType: ProjectTypeType; setShowCildren: any; showCildren: any }) {
  const [projectType, setProjectType] = useState<ProjectTypeType>(ProductType);
  const [arrowDirection, setArrowDirection] = useState<string>("down");

  useEffect(() => {}, [projectType]);

  const ShowHide = () => {
    setShowCildren(!showCildren);
    if (showCildren) {
      setArrowDirection("down");
    } else {
      setArrowDirection("up");
    }
  };

  const GetArrow = () => {
    return arrowDirection;
  };

  return (
    <div className="ProjectTypeHeader" onClick={() => ShowHide()}>
      <div className="option">
        <i className={"fas fa-chevron-" + arrowDirection}></i> {ProductType.Description}
      </div>
    </div>
  );
}

export default ProjectTypeHeader;
